import { ListCinema } from "./listCinema";

const cinema = new ListCinema();
cinema.init();
